import {EventBase} from "shared/core/Events/EventManager";


export class RenderMark extends EventBase {
    ReturnType: JSX.Element;

    constructor(public children:any,public mark:any,public attributes:any) {
        super();
    }

    public static GetName() {
        return 'RenderMark';
    }
}